import React, { useState, useContext } from "react";
import { ReactComponent as Close } from "../../assets/icons/x.svg";
import axios from "axios";
import { NotificationContext } from "../../Context/NotificationContext";
import { Loader } from "react-feather";
import "./ForgotPasswordForm.css";
import { FormTextInput } from "../../Components/FormTextInput";
import { getFullHttpUrl } from "../../firebase.config";
import { EAST1, EAST4 } from "../../utility/enums";

export default function ForgotPasswordForm({
  isLoginOpen,
  goToVerification,
  backToSignIn,
  email,
  setEmail,
}) {
  const [emailError, setEmailError] = useState(false);
  const { showNotification } = useContext(NotificationContext);
  const [isLoading, setIsLoading] = useState(false);
  const [btnText, setBtnText] = useState("Send Code");

  const closeForm = () => {
    isLoginOpen();
  };

  const verificationStart =async () => {
    if(email === "" || !/\S+@\S+\.\S+/.test(email)){
      setEmailError(true);
      return;
    }
    setBtnText("Sending");
    setIsLoading(true);
    
    try {
      axios.post(getFullHttpUrl("generateForgotPassCode", EAST4), {
        email: email.toLowerCase(),
      });
      goToVerification();
      showNotification(
        "Success",
        "Verification code sent, Please check your email for verification code!",
        "success"
      );
    } catch (error) {
      // console.error(error);
      setIsLoading(false);
      setBtnText("Send Code");
      showNotification(
        "Error",
        "Error occurred while sending verification code. Please try again or contact support!",
        "error"
      );
      
    } finally {
      setIsLoading(false);
      setBtnText("Send Code");
    }
  };

  const handleEmailChange = (value) => {
    setEmail(value);
    setEmailError(false);
  }

    const triggerEnter = () => {
      if (!(email === "")) {
        verificationStart()
      }
    }
  
  const handleEmailBlur = () => {
    if (email === "" || !/\S+@\S+\.\S+/.test(email)) {
      setEmailError(true);
    }
  };
  
  return (
    <div className="forgotPasswordForm">
      <div className="forgotPasswordFormHeader">
        <h2 className="forgotPasswordFormHeaderTitle">Forgot Password</h2>
        <Close className="signInFormIcon" onClick={closeForm} />
      </div>

      <span className="forgotPasswordFormText">
        Please enter the email associated with your account
      </span>

      <div className="forgotPassworFormContainer">
        <FormTextInput email={true}  placeholder={"Email"} incorrect={emailError} clearInputIcon={true} value={email} onBlur={handleEmailBlur} onChange={handleEmailChange} onKeyDown={(e) => e.key === "Enter" && triggerEnter()}/>
      </div>

      {emailError ? (
        <span className="forgotPasswordFormError">
          Invalid email format. Example: example@example.com
        </span>
      ) : null}
      <button
        className="forgotPasswordFormButton"
        disabled={email === "" || isLoading || emailError}
        onClick={() => verificationStart()}
      >
        {btnText}
        {isLoading && <Loader className="btnLoader"/>}
      </button>

      <span
        className="forgotPasswordFormBackToSignIn"
        onClick={() => backToSignIn()}
      >
        Back to Sign In
      </span>
    </div>
  );
}
